import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http:HttpClient) { 
  }

  HandleLogin(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/login`;
    return this.http.post<any>(apiURL, data);
  }

  ForgotPassword(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/forgot-password`;
    return this.http.post<any>(apiURL, data);
  }

  CheckLink(id: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/check-url-token/${id}`;
    return this.http.get<any>(apiURL);
  }

  ResetPassword(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/reset-password`;
    return this.http.post<any>(apiURL, data);
  }

  SignUp(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/client-signup`;
    return this.http.post<any>(apiURL, data);
  }

  loginUserInformation(): Observable<any> {
    const apiURL = `${environment.auth_url}/authorization/v1/login-user-information`;
    return this.http.get<any>(apiURL);
  }

  Logout(): Observable<any> {
    const apiURL = `${environment.auth_url}/authorization//v1/logout`;
    return this.http.post<any>(apiURL,'');
  }

  VerifyOtp(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/onboarding-check-otp`;
    return this.http.post<any>(apiURL, data);
  }

  GetOtp(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/onboarding-send-otp`;
    return this.http.post<any>(apiURL, data);
  }  

  CreateNewToken(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/refresh-token`;
    return this.http.post<any>(apiURL, data);
  }
  
  ChangePassword(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authorization/v1/change-password`;
    return this.http.post<any>(apiURL, data);
  }
  
}
